import { defineStore } from "pinia";
import {
  getPublicityTop,
  getPublicityMobil,
  getPublicityDesktop,
  generateGeoHash
} from '@/config/use_cases/home';
import {
  get_current_user
} from '@/config/use_cases/login';
import {
  getCities,
  getCountries,
  getMunicipalities,
  getStates
} from '@/config/use_cases/ubicacion';
import { useUserStore } from "@/stores/user";

export const useHomeStore = defineStore("home", {
  state: () => ({
    userStore: useUserStore(),
    top_publicity: {} as Record<string, any>,
    mobil_publicity: {} as Record<string, any>,
    desktop_publicity: {} as Record<string, any>,
    city_name: '',
    user_name: '',
    user_email: '',
    user_id: '',
    city_id: '',
    paises: [] as any[],
    estados: {} as Record<string, any>,
    municipios: {} as Record<string, any>,
    ciudades: {} as Record<string, any>,
  }),

  getters: {
    getPublicityTopCurrent: (state) => state.top_publicity,
    getPublicityMobilCurrent: (state) => state.mobil_publicity,
    getPublicityDesktopCurrent: (state) => state.desktop_publicity,

    getCityName: (state) =>
      state.user_name ? state.city_name : '',

    getUserName: (state) => {
      const user_name = localStorage.getItem('user_name') || '';
      state.user_name = user_name;
      const user_email = localStorage.getItem('user_email') || '';
      state.user_email = user_email;
      return user_name || state.city_name;
    },

    getUserIsLogged: () => {
      const user_id = localStorage.getItem('user_id') || '';
      return !!user_id;
    },
    
  },

  actions: {
    getGeohash(location: [number, number]) {
      return generateGeoHash(location);
    },
    updateUserName(user_name: string) {
      this.user_name = user_name;
    },
    updateCityName(city_name: string) {
      this.city_name = city_name;
    },
    async getPublicityTopAction() {
      const city_id = localStorage.getItem('city_id') || '';
      const in_data = this.top_publicity[city_id];

      if (in_data?.length) return in_data;

      const data = await getPublicityTop(city_id);
      this.top_publicity[city_id] = data;
      return data;
    },

    async getPublicityMobilAction() {
      const city_id = localStorage.getItem('city_id') || '';
      const in_data = this.mobil_publicity[city_id];

      if (in_data?.length) return in_data;

      const data = await getPublicityMobil(city_id);
      this.mobil_publicity[city_id] = data;
      return data;
    },

    async getPublicityDesktopAction() {
      const city_id = localStorage.getItem('city_id') || '';
      const in_data = this.desktop_publicity[city_id];

      if (in_data?.length) return in_data;

      const data = await getPublicityDesktop(city_id);
      this.desktop_publicity[city_id] = data;
      return data;
    },

    // async loadDefaultInformation() {
    //   const data: any = await getDefault();
    //   localStorage.clear();

    //   localStorage.setItem('country_id', data.country_id);
    //   localStorage.setItem('state_id', data.state_id);
    //   localStorage.setItem('municipality_id', data.municipality_id);
    //   localStorage.setItem('city_id', data.city_id);
    //   localStorage.setItem('city_name', data.city_name);
    // },

    async getAllCountry() {
      if (this.paises.length) return this.paises;
      const data = await getCountries();
      this.paises = data;
      return data;
    },

    async getAllStatesByCountry() {
      const country_id = this.userStore.getCountryId;
      const estados = this.estados[country_id];
      if (estados?.length > 0) return estados;
      const data: any = await getStates(country_id);
      this.estados[country_id] = data;
      return data;
    },

    async getAllMunicipalitiesByState(state_id: string) {
      const municipios = this.municipios[state_id];
      if (municipios?.length > 0) return municipios;
      const data: any = await getMunicipalities(state_id);
      this.municipios[state_id] = data;
      return data;
    },

    async getAllCitiesByMunicipality(municipality_id: string) {
      // const municipality_id = localStorage.getItem('municipality_id') || '';
      const ciudades = this.ciudades[municipality_id];

      if (ciudades?.length > 0) return ciudades;

      // const state_id = localStorage.getItem('state_id') || '';
      const data = await getCities(municipality_id);

      this.ciudades[municipality_id] = data;
      return data;
    },

    async getCurrentUser() {
      const user = await get_current_user();
      return user;
    },
  },
});
